
import { set } from './util'
export function Select ({ ref, list }) {
    return {
        data() {
            return {
                // remote: false
            }
        },
        mounted() {
            if (!this.remote) {
                return;
            }
            const select = this.getSelect();
            select.$on('visible-change', (visible)=> {
                if (visible) {
                    this.setSelectData()
                }
            });
            // this.$once('hook:beforeDestroy', () => {
            //     select.$off('visible-change')
            // });
        },
        methods: {
            getSelect() {
                return this.$refs[ref]
            },
            setSelectData() {
                const options = this.getSelect().selected|| [];
                const listData = options.map(v=> {
                    return v.$options.propsData
                });
                if (list) {
                    set(this, list, listData)
                }
            },
        }

    }
}
